import { render } from "./DamageData.vue?vue&type=template&id=7af835c7&scoped=true"
import script from "./DamageData.vue?vue&type=script&lang=js"
export * from "./DamageData.vue?vue&type=script&lang=js"

import "./DamageData.vue?vue&type=style&index=0&id=7af835c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7af835c7"

export default script